import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { emailSchema } from '@common/validation/schemas';

export type OsasResendPatientInviteCustomControlData = {
    patient: { emailAddress: string | null };
};

const OsasResendPatientInviteDraft: TypedSchema<OsasResendPatientInviteCustomControlData> = {
    patient: Koi.object({
        emailAddress: emailSchema.allow(null),
    }),
};

const OsasResendPatientInviteFinal: TypedSchema<OsasResendPatientInviteCustomControlData> = {
    patient: Koi.object({
        emailAddress: emailSchema,
    }),
};

export const osasResendPatientInviteDraftSchema = Koi.object(OsasResendPatientInviteDraft);
export const osasResendPatientInviteFinalSchema = Koi.object(OsasResendPatientInviteFinal);
